export default __webpack_public_path__ + "maps-examples-point-conversion-thumbnail-960-0d287b5a3f58475e9cb7607e35037de2.png";